import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    {
        path: '/trackvideo/',
        name: 'Track Video',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.tv1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/trackvideo/')
    },
]